/**
 * Application entry point
 * Initializes Vue app with router and state management
 */

import { createApp } from 'vue'
import './style.css'
import App from './App.vue'
import router from './router'
import pinia from './stores'
import { useAuthStore } from './stores/auth'

const app = createApp(App)

// Install plugins
app.use(router)
app.use(pinia)

// Initialize auth state listener
const authStore = useAuthStore()
authStore.initializeAuthListener()

// Mount app
app.mount('#app')
